import React from "react";
import Grid from "@material-ui/core/Grid";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Radio from "@material-ui/core/Radio";
import TablaTagsFactor from "../components/TablaTagsFactor";
import TablaTagSinFactor from "../components/TablaTagSinFactor";
import Typography from "@material-ui/core/Typography";
import {ajustesResources, revisarResources, tagResources} from "../endpoints";
import DialogExportar from "../components/DialogExportar";
import SnackbarAlert from "../components/SnackbarAlert";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import DialogActions from "@material-ui/core/DialogActions";
import AgregarConteo from "../components/AgregarConteo";
import AddIcon from "@material-ui/icons/Add";
import useToken from "../useToken";

class DetalleTag extends React.Component{
    constructor(props) {
        super(props);
        this.state ={
            value: 'desagrupado',
            tag: props.match.params.tag,
            loading: false,
            showTabla: false,
            factor:false,
            sin_factor:false,
            open: false,
            openSnack: false,
            severity: "",
            message: "",
            reporte: "",
            params: "",
            motivos: [],
            sin_datos:false,
            eliminar_tag:false,
            agregar_conteo:false,
            tag_no_revisado: true,
            tag_revisado:true,
            tipo_tag: '',
            origen: '',
        }

    }

    getMotivos = () =>{
        ajustesResources.getMotivosAjustes().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            this.setState({motivos:result})
        }).catch(error=> {
            console.log(error)
        });
    }

    getUbicacionTag = () =>{
        tagResources.consultarUbicacionTag(this.state.tag).then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if (result.descripcion === null){
                this.setState({descripcion_ubicacion:"SIN ZONIFICACIÓN",showTabla: true,})
            }
            else{
                this.setState({descripcion_ubicacion:result.descripcion.ubicacion_path, tipo_tag: result.descripcion.tipo_tag, showTabla: true,
                    mandatorio:result.descripcion.tipo_tag.toLowerCase().replace('(',"").replace(")", '')}, ()=>{
                    if (result.descripcion.tipo_tag.toLowerCase().replace('(',"").replace(")", '') === 'mandatorio/espejo'){
                        this.setState({origen:'mandatorio/espejo'})
                    }
                    else{
                        this.setState({origen:'detalle_tag'})
                    }
                })

            }
        }).catch(error=> {
            console.log(error)
        });
    }

    handleChange = (event) => {
        this.setState({value: event.target.value, showTabla: !this.state.showTabla});
        setTimeout(() => {
            // After X seconds set the show value to false
            this.setState({showTabla:!this.state.showTabla})
        }, 30)
    }

    obtenerTipoCampos = () =>{
        tagResources.obtenerTipoCampos().then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result === "con_factor"){
                this.setState({factor: true})
            }
            else{
                this.setState({sin_factor:true})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    getRevisiontag = () =>{
        revisarResources.getRevisionTag(this.state.tag).then(async response => {
            if (response.ok) {
                return await response.json();
            } else {
                throw new Error('Something went wrong ...');
            }
        }).then(result => {
            if(result.revisado === true){
                this.setState({tag_revisado:true,tag_no_revisado:false})
            }
            else{
                this.setState({tag_no_revisado:true,tag_revisado:false})
            }
        }).catch(error=> {
            console.log(error)
        });
    }

    componentDidMount(){
        this.obtenerTipoCampos()
        this.getMotivos()
        this.getRevisiontag();
        this.getUbicacionTag();
        let datos_inv = useToken.getDatos()
        this.setState({cliente:datos_inv.app})
    }

    handleClose = () =>{
        this.setState({open:false, agregar_conteo:false})
    }

    eliminarTag = () =>{
        this.setState({openSnack: false, message: "", severity: ""})
        tagResources.eliminarTag(this.state.tag,this.state.motivo.id).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                if(result.status_code === 200){
                    this.setState({
                        eliminar_tag:false,
                        showTabla:false,
                        openSnack: true,
                        message: result.message,
                        severity: result.severity})
                }
                else{
                    this.setState({
                        eliminar_tag:false,
                        openSnack: true,
                        message: result.message,
                        severity: result.severity})
                }
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            console.error(error);
            this.setState({
                eliminar_tag:false,
                openSnack: true,
                message: "Ha ocurrido un error inesperado",
                severity: "error"})
        });
    }

    enviarDatosReportes =(tipo)=>{
        let params = this.state.tag
        let reporte = ""
        if (tipo !== 'conteo_inicial' && tipo !== 'con_hua'){
            if(this.state.factor === true && this.state.sin_factor === false){
                if (this.state.value === "desagrupado") {
                    reporte = "tag_detalle_factor"
                }
                else if (this.state.value === "agrupado") {
                    reporte = "tag_agrupado_factor"
                }
                else {
                    reporte = "tag_consolidado"
                }
            }
            else if (this.state.factor === false && this.state.sin_factor === true){
                if (this.state.value === "desagrupado") {
                    reporte = "tag_detalle"
                }
                else if (this.state.value === "agrupado") {
                    reporte = "tag_agrupado"
                }
                else {
                    reporte = "tag_consolidado"
                }
            }
        }
        else{
            if (tipo === 'conteo_inicial'){
                reporte = "tag_detalle_conteo_original"
            }
            else{
                reporte = "tag_detalle_con_hua"
            }
        }

        this.setState({open: true, reporte: reporte, params: params,openSnack:false})
    }

    handleChangeLoading = (estado) =>{
        //NO BORRAR
        if(estado === "sin datos"){
            this.setState({sin_datos:true})
        }
        else{
            this.setState({sin_datos:false})
        }
    }

    refrescar =(estado,severity) =>{
        this.setState({ open: false, agregar_conteo:false, openSnack: false})
        if(severity){
            this.setState({openSnack:true, message: estado, severity: severity})
        }
    }

    refrescarDatos = (estado, severity) => {
        this.setState({ open: false, agregar_conteo: false, openSnack: false }, () => {
            if (severity) {
                setTimeout(() => {
                    this.setState({
                        openSnack: true,
                        message: estado,
                        severity: severity
                    });
                }, 50); // un pequeño delay fuerza el re-render
            }

            if (severity === "success") {
                this.setState({ showTabla: !this.state.showTabla }, () => {
                    setTimeout(() => {
                        this.setState({ showTabla: !this.state.showTabla });
                    }, 10);
                    this.getRevisiontag();
                });
            }
        });
    };

    handleClick = ()=>{
        this.props.history.push("/detalles_conflictos/" + this.state.tag)
    }

    revisarTag = (tag) =>{
        revisarResources.revisarTag(tag).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.refrescarDatos(result.message,result.severity)
                this.getRevisiontag();
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.refrescarDatos("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }

    desrevisarTag = (tag) =>{
        revisarResources.desrevisarTag(tag).then(async response => {
            if (response) {
                return await response.json();
            }
        }).then(result => {
            if(result.message){
                this.refrescarDatos(result.message,result.severity)
                this.getRevisiontag();
            }
            else{
                throw new Error('Something went wrong ...');
            }
        }).catch(error=> {
            this.refrescarDatos("Ha ocurrido un error inesperado","error")
            console.log(error)
        });
    }

    render() {
        return(
            <div>
                <Grid  container spacing={2} direction={"row"} justifyContent={"flex-start"} alignItems="center">
                    <Grid item xs={12}>
                        <Typography variant="h4">Detalle Tag: {this.state.tag} -- {this.state.descripcion_ubicacion} {this.state.tipo_tag}</Typography>
                    </Grid>
                </Grid>
                <Grid  container spacing={2} direction={"row"} justifyContent={"flex-start"} alignItems="center">
                    <Grid item>
                        <RadioGroup style={{ display: 'inline-block'}} aria-label="gender" name="value" value={this.state.value} onChange={this.handleChange}>
                            <FormControlLabel value="desagrupado" control={<Radio/>} label="Desagrupado" />
                            <FormControlLabel value="agrupado" control={<Radio/>} label="Agrupado" />
                            <FormControlLabel value="consolidado" control={<Radio/>} label="Consolidado" />
                        </RadioGroup>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>this.enviarDatosReportes('normal')}
                            disabled={!this.state.tag}
                        >Exportar</Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="secondary"
                            onClick={() => this.setState({eliminar_tag: true})}
                            disabled={this.state.sin_datos}
                        >Eliminar tag</Button>
                    </Grid>
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={this.handleClick}
                        >Ver detalle ampliado</Button>
                    </Grid>
                    <Grid item>
                        <Button startIcon={
                            <AddIcon/>} variant="contained" color="primary" onClick={()=>{this.setState({agregar_conteo:true})}}>
                            Agregar conteo</Button>
                    </Grid>
                    {this.state.cliente !== "sodimac" &&
                    <Grid item hidden={this.state.tag_revisado}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.revisarTag(this.state.tag)}
                            disabled={this.state.sin_datos}
                        >Revisar tag</Button>
                    </Grid>}
                    {this.state.cliente !== "sodimac" &&
                    <Grid item   hidden={this.state.tag_no_revisado}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => this.desrevisarTag(this.state.tag)}
                            disabled={this.state.sin_datos}
                        >Des-revisar tag</Button>
                    </Grid>
                    }
                    {this.state.cliente === "fashionspark-cd" &&
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>this.enviarDatosReportes('con_hua')}
                            disabled={!this.state.tag}
                        >Exportar con hu</Button>
                    </Grid>}
                    {this.state.cliente === "tottus" &&
                    <Grid item>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={()=>this.enviarDatosReportes('conteo_inicial')}
                            disabled={!this.state.tag}
                        >Exportar conteo inicial</Button>
                    </Grid>}
                </Grid>
                <br/>
                {this.state.showTabla && this.state.factor && <TablaTagsFactor getRevision={this.getRevisiontag} origen={"consultar"} mandatorio={this.state.tipo_tag.toLowerCase().replace('(',"").replace(")", '')} tag={this.state.tag} tipo={this.state.value} handleLoading={this.handleChangeLoading}/>}
                {this.state.showTabla && this.state.sin_factor && <TablaTagSinFactor getRevision={this.getRevisiontag} origen={"consultar"} mandatorio={this.state.tipo_tag.toLowerCase().replace('(',"").replace(")", '')} tag={this.state.tag} tipo={this.state.value} handleLoading={this.handleChangeLoading}/>}
                { this.state.open && <DialogExportar reporte={this.state.reporte}  origen={'otro'} params={this.state.params} refrescar={this.refrescar} handleClose={this.handleClose} />}
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
                {this.state.agregar_conteo && <AgregarConteo origen={this.state.origen} tag={this.state.tag} handleClose={this.handleClose} refrescar={this.refrescarDatos} articulo={''}/>}
                <Dialog
                    open={this.state.eliminar_tag}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <DialogTitle id="alert-dialog-title">Eliminar tag {this.state.tag}</DialogTitle>
                    <DialogContent>
                        <Grid container spacing={2} alignItems="flex-end">
                            <Grid item xs={12}>
                                Seleccione un motivo:
                                <Autocomplete
                                    id="size-small-standard"
                                    onChange={(event, newValue) => {
                                        if(newValue === null) {
                                            this.setState({motivo: ""})
                                        }
                                        else{
                                            this.setState({motivo: newValue})
                                        }
                                    }}
                                    size="small"
                                    options={this.state.motivos}
                                    noOptionsText={"No hay opciones"}
                                    getOptionLabel={(option) => option.descripcion|| ""}
                                    renderInput={(params) => (
                                        <TextField {...params} variant="standard" label="Motivo" placeholder="Disponibles" />
                                    )}
                                />
                            </Grid>
                            <Grid item xs={12}>
                                Esta acción es irreversible. Está seguro que desea eliminar el tag {this.state.tag}?
                            </Grid>
                        </Grid>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" color="secondary"  onClick={() => this.setState({eliminar_tag:false})}>
                            Cancelar
                        </Button>
                        <Button variant="contained" color="primary" disabled={!this.state.motivo} onClick={this.eliminarTag}>
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>

            </div>
        )
    }
}

export default DetalleTag;